/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AllocationRuleTableListParams
} from '../../model/allocationRuleTableListParams'
import type {
  GenericTableData
} from '../../model/genericTableData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Returns a list of allocation rules
 */
export const allocationRuleTableList = (
    fundFamilyId: string,
    params?: AllocationRuleTableListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-table/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAllocationRuleTableListQueryKey = (fundFamilyId: string,
    params?: AllocationRuleTableListParams,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule-table/`, ...(params ? [params]: [])] as const;
    }

    
export const getAllocationRuleTableListQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleTableList>>, TError = unknown>(fundFamilyId: string,
    params?: AllocationRuleTableListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleTableList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleTableListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleTableList>>> = ({ signal }) => allocationRuleTableList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allocationRuleTableList>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleTableListQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleTableList>>>
export type AllocationRuleTableListQueryError = unknown

export const useAllocationRuleTableList = <TData = Awaited<ReturnType<typeof allocationRuleTableList>>, TError = unknown>(
 fundFamilyId: string,
    params?: AllocationRuleTableListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleTableList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleTableListQueryOptions(fundFamilyId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllocationRuleTableListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleTableList>>, TError = unknown>(fundFamilyId: string,
    params?: AllocationRuleTableListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleTableList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleTableListQueryKey(fundFamilyId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleTableList>>> = ({ signal }) => allocationRuleTableList(fundFamilyId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleTableList>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleTableListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleTableList>>>
export type AllocationRuleTableListSuspenseQueryError = unknown

export const useAllocationRuleTableListSuspense = <TData = Awaited<ReturnType<typeof allocationRuleTableList>>, TError = unknown>(
 fundFamilyId: string,
    params?: AllocationRuleTableListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleTableList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleTableListSuspenseQueryOptions(fundFamilyId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAllocationRuleTableListLoader = (queryParamsOrFn?: (AllocationRuleTableListParams | ((params: Params) => AllocationRuleTableListParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAllocationRuleTableListQueryKey(fundFamilyId, queryParams),
              queryFn: () => allocationRuleTableList(fundFamilyId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      